import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Downloads from './pages/Downloads';
import About from './pages/About';
import Contact from './pages/Contact';
import Uploads from './pages/Uploads';  // Add new imports
import EULA from './pages/EULA';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import CursorGlowEffect from './components/CursorGlowEffect';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen">
        <CursorGlowEffect />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/uploads" element={<Uploads />} /> 
          <Route path="/eula" element={<EULA />} />
          <Route path='/privacy_policy' element={<PrivacyPolicy />} />
          {<Route path="*" element={<Home />} /> /* Redirect invalid routes to Home ??! */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;